import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Card/card';
import { CardContext } from './Card';
export var CardTitle = function CardTitle(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'div' : _a$component,
      props = __rest(_a, ["children", "className", "component"]);

  var _React$useContext = React.useContext(CardContext),
      cardId = _React$useContext.cardId,
      registerTitleId = _React$useContext.registerTitleId;

  var Component = component;
  var titleId = cardId ? "".concat(cardId, "-title") : '';
  React.useEffect(function () {
    registerTitleId(titleId);
    return function () {
      return registerTitleId('');
    };
  }, [registerTitleId, titleId]);
  return React.createElement(Component, Object.assign({
    className: css(styles.cardTitle, className),
    id: titleId || undefined
  }, props), children);
};
CardTitle.displayName = 'CardTitle';